<template>
  <div>
    <StationMap />
  </div>
</template>

<script>
import StationMap from "@/components/map/StationMap.vue";

export default {
  components: {
    StationMap,
  },
};
</script>